"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooter = void 0;

var _preact = require("preact");

var ModalFooter = function ModalFooter(props) {
  return (0, _preact.h)("footer", {
    className: "control-modal-footer"
  }, props.children);
};

exports.ModalFooter = ModalFooter;